import i18n from 'i18next';

export default () => ({
    name: [{ validate: 'required', message: i18n.t('name_required') }],
    lastName: [{ validate: 'required', message: i18n.t('lastnames_required') }],
    email: [{ validate: 'required', message: i18n.t('required_email') }, { validate: 'email', message: i18n.t('invalid_email') }],
  });
